import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faEnvelope,
  faPhone,
  faChevronDown,
  faChevronUp,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import AccountSidebar from "../../components/AccountSidebar/AccountSidebar";
import { sendMailApi } from "../../services/api.services";
import { language } from "../../languageProvider/language/language";
import { defaultLanguage } from "../../helper/utility";
import "../Profile.page.css";

const FAQ = [
  { q: "Come posso effettuare un ordine?", a: "Puoi sfogliare il volantino, aggiungere i prodotti alla lista della spesa e procedere con l'invio dell'ordine dalla sezione carrello." },
  { q: "Come posso modificare o annullare un ordine?", a: "Puoi annullare un ordine dalla sezione Ordini, cliccando sull'ordine e selezionando 'Annulla'. La modifica è possibile solo se l'ordine non è ancora in elaborazione." },
  { q: "Come funziona il programma punti?", a: "Accumuli punti ad ogni acquisto. I punti possono essere utilizzati per riscattare premi dal catalogo nella sezione Premi." },
  { q: "Come posso cambiare la mia password?", a: "Vai nella sezione Profilo e clicca su 'Cambia password'. Inserisci la nuova password e confermala." },
];

function SupportPage() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);
  const [contactForm, setContactForm] = useState({ subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [sendError, setSendError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setSendError(null);
    try {
      const res = await sendMailApi({
        type: "support",
        subject: contactForm.subject,
        message: contactForm.message,
      });
      if (res.status === 200) {
        setSent(true);
        setContactForm({ subject: "", message: "" });
        setTimeout(() => setSent(false), 4000);
      } else {
        setSendError(res.message || "Errore nell'invio del messaggio");
      }
    } catch {
      setSendError("Errore nell'invio del messaggio");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="up-page">
      <div className="up-topbar">
        <div className="up-topbar__left">
          <div className="up-topbar__back" onClick={() => navigate("/leaflet")}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
          <h1 className="up-topbar__title">{language[defaultLanguage].assistenza}</h1>
        </div>
      </div>

      <div className="up-layout">
        <AccountSidebar />
        <div className="up-main">
          {/* Contact info */}
          <div className="up-card">
            <h2 className="up-card__title" style={{ marginBottom: "14px" }}>Contatti</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#555", fontSize: "0.92rem" }}>
                <FontAwesomeIcon icon={faEnvelope} style={{ color: "#888", width: "18px" }} />
                <span>supporto@esempio.it</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#555", fontSize: "0.92rem" }}>
                <FontAwesomeIcon icon={faPhone} style={{ color: "#888", width: "18px" }} />
                <span>+39 800 123 456</span>
              </div>
            </div>
          </div>

          {/* FAQ */}
          <div className="up-card">
            <h2 className="up-card__title" style={{ marginBottom: "14px" }}>Domande frequenti</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              {FAQ.map((faq, i) => (
                <div key={i} style={{
                  border: "1px solid #f0f0f0",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}>
                  <div
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    style={{
                      padding: "12px 14px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      backgroundColor: openFaq === i ? "#fafafa" : "#fff",
                      fontWeight: 600,
                      fontSize: "0.9rem",
                      color: "#333",
                    }}
                  >
                    <span>{faq.q}</span>
                    <FontAwesomeIcon
                      icon={openFaq === i ? faChevronUp : faChevronDown}
                      style={{ color: "#bbb", fontSize: "0.75rem", marginLeft: "10px", flexShrink: 0 }}
                    />
                  </div>
                  {openFaq === i && (
                    <div style={{
                      padding: "10px 14px 14px",
                      fontSize: "0.88rem",
                      color: "#666",
                      lineHeight: 1.5,
                      borderTop: "1px solid #f0f0f0",
                    }}>
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Contact form */}
          <div className="up-card">
            <h2 className="up-card__title" style={{ marginBottom: "14px" }}>Invia un messaggio</h2>
            {sent ? (
              <div style={{
                textAlign: "center",
                padding: "20px",
                color: "#28a745",
                fontWeight: 600,
                fontSize: "0.95rem",
              }}>
                Messaggio inviato con successo!
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="up-form__group">
                  <label className="up-form__label">Oggetto</label>
                  <input
                    type="text"
                    className="up-form__input"
                    value={contactForm.subject}
                    onChange={(e) => setContactForm({ ...contactForm, subject: e.target.value })}
                    required
                    placeholder="Oggetto del messaggio"
                  />
                </div>
                <div className="up-form__group">
                  <label className="up-form__label">Messaggio</label>
                  <textarea
                    className="up-form__input"
                    value={contactForm.message}
                    onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                    required
                    placeholder="Scrivi il tuo messaggio..."
                    rows={4}
                    style={{ resize: "vertical" }}
                  />
                </div>
                {sendError && (
                  <div style={{ color: "#dc3545", fontSize: "0.88rem", marginBottom: "10px" }}>
                    {sendError}
                  </div>
                )}
                <button
                  type="submit"
                  className="up-btn up-btn--primary"
                  disabled={sending}
                >
                  {sending ? (
                    <FontAwesomeIcon icon={faSpinner} spin />
                  ) : (
                    "Invia messaggio"
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupportPage;
